export default __webpack_public_path__ + "static/media/ico_menu_close.e705e352.svg";